module.exports = __webpack_public_path__ + "assets/fonts/Guroo-Producer.eot";


/*****************
 ** WEBPACK FOOTER
 ** ./src/styles/guroo-producer/fonts/Guroo-Producer.eot
 ** module id = 349
 ** module chunks = 0
 **/